// extracted by mini-css-extract-plugin
module.exports = {"iframe":"CryptoWidget-module--iframe--1wl2P"};